export const ReceiptTableHeader = {
  columns: {
    idrec: {
      title: 'Номер квитанции',
      filter: true
    },
    eui: {
      title: 'Устройство',
      filter: true
    },
    createtime: {
      title: 'Дата отправки',
      filter: true
    },
    sent: {
      title: 'Статус отправки',
      filter: true
    }
  },
  actions: {
    add:    false,
    edit:   false,
    delete: false
  },
  pager: {
    perPage: 10
  }
};



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/models/ReceiptsInfoTableHeaders.ts